// import { toast } from 'react-toastify';

export const saveToken = (token, expiryTime=3600) => {
    sessionStorage.setItem('token', token);
    const expiryTimestamp = new Date().getTime() + expiryTime * 1000; // Assuming expiryTime is in seconds
    sessionStorage.setItem('expiryTimestamp', expiryTimestamp);

    // Set a timeout for 5 minutes before the token expires
    // const notifyBeforeExpiry = expiryTime - 300; // 300 seconds = 5 minutes
    // setTimeout(() => { Commenting out for now until I get toasts to work properly
    //     toast.warn('Your session will expire in 5 minutes. Please refresh or re-login to avoid being logged out.', {
    //         position: "top-right",
    //         autoClose: 30000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //     });
    // }, notifyBeforeExpiry * 1000);
};

export const isTokenExpired = () => {
    const expiryTimestamp = sessionStorage.getItem('expiryTimestamp');
    return new Date().getTime() > expiryTimestamp;
};

export const clearSession = () => {
    sessionStorage.clear();
};